import { useEffect } from "react";

import { Button, Icon_CheckmarkFilled60, SpinnerCenter } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import useAccount from "../../hooks/useAccount";
import { useSetAppProperties } from "../../hooks/useGetAppProperties";
import useTranslation from "../../hooks/useTranslation";
import { getShaprURLProtocol } from "../../urlUtils";
import Heading from "../Heading/Heading";

import style from "./ProgressiveProfilingSuccess.module.css";

const ProgressiveProfilingSuccess = () => {
  const { t, m } = useTranslation();
  const { data } = useAccount();
  const { mutateAsync: mutateAppProperties } = useSetAppProperties();
  useEffect(() => {
    if (data && data.id) {
      mutateAppProperties({
        segmentation_v2_progressive_profiling_finished_at: new Date().toISOString(),
      });
    }
  }, [data, mutateAppProperties]);

  if (!data) {
    return <SpinnerCenter />;
  }

  return (
    <div className={style.progressiveProfilingSuccess}>
      <div className={style.modalContainer}>
        <Icon_CheckmarkFilled60 className={style.image} />
        <Heading type="h1">{t(m.ProgressiveProfiling.General.ThankYou)}</Heading>
        <div>
          <p className={style.message}>
            {t(m.ProgressiveProfiling.General.YourAnswersWereSubmittedSuccessfully)}
          </p>
        </div>
        <div className={classNames(style.footer, style.footerSuccess)}>
          <Button
            className={style.backToShaprButton}
            onClick={() => {
              const protocol = getShaprURLProtocol();
              const url = `${protocol}://progressiveProfilingSurveyCompleted?user=${data.id}`;

              window.location.replace(url);
            }}
          >
            {t(m.ProgressiveProfiling.General.BackToShapr3DApp)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProgressiveProfilingSuccess;
